import request from '@/utils/request'

let HorderApi = {

  /*订单管理列表*/
  list(data) {
    return request._post('/shop/plus.horder.Index/index', data);
},
/*添加订单管理*/
add(data) {
    return request._post('/shop/plus.horder.Index/add', data);
},
/*生成支付二维码*/
genCode(data) {
    return request._post('/shop/plus.horder.Index/genCode', data);
},
/*修改订单管理*/
edit(data) {
    return request._post('/shop/plus.horder.Index/edit', data);
},
/*删除订单管理*/
del(data) {
    return request._post('/shop/plus.horder.Index/del', data);
},

orderDetail(data) {
    return request._post('/shop/plus.horder.Index/orderDetail', data);
},

// 下单  
createOrder(data) {
    return request._post('/shop/plus.horder.Index/createOrder', data);
},

// 子订单审核
passorder(data,errorback) {
    return request._post('/shop/plus.horder.Index/supplyAudit', data, errorback);
},

// 子订单详情
sorderDetail(data,errorback) {
    return request._post('/shop/plus.horder.Index/subDetail', data, errorback);
},

// 发货
deliverGoods(data,errorback) {
    return request._post('/shop/plus.horder.Index/supplierShip', data, errorback);
},

// 重新提交审核
resubmit(data,errorback) {
    return request._post('/shop/plus.horder.Index/reSubmitAudit', data, errorback);
},

// 取消订单
cancelOrder(data,errorback) {
    return request._post('/shop/plus.horder.Index/cancel', data, errorback);
},

// 删除订单
delOrder(data,errorback) {
    return request._post('/shop/plus.horder.Index/del', data, errorback);
},

// 确认收货
receiveOrder(data,errorback) {
    return request._post('/shop/plus.horder.Index/supplierReceive', data, errorback);
},

// 生产订单
makeOrder(data,errorback) {
    return request._post('/shop/plus.horder.Index/supplierToGenerate', data, errorback);
},

// 支付订单
payOrder(data,errorback) {
    return request._post('/shop/plus.horder.Index/offlinePay', data, errorback);
},

// 获取筛选条件
sceenList(data, errorback) {
    return request._get('/shop/plus.horder.Index/getSearchSelectList', data, errorback);
},

/*订单管理详情*/
detail(data) {
  return request._post('/shop/plus.horder.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.horder.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.horder.Setting/getSetting', data, errorback);
    },
    payment(data, errorback) {
        return request._get('/shop/plus.horder.Index/payment', data, errorback);
    },
}
export default HorderApi;



// WEBPACK FOOTER //
// ./src/api/horder.js